import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  getView,
  saveViewGroupOrder,
  deleteViewGroupColumn,
} from "features/planner/planner.actions";

import View from "features/planner/components/View/View";
import EditCardModal from "features/planner/components/Card/EditCardModal";
import { getSearchTermFromState } from "features/planner/planner.selectors";
import CreateCardModal from "features/planner/components/Card/CreateCardModal";
import EditCompanyModal from "features/planner/components/View/EditCompanyModal";
import ViewLayoutModeInfoPanel from "features/planner/components/ViewLayoutModeInfoPanel";
import SearchResultTopPanel from "features/planner/components/Search/SearchResultTopPanel";
import EditLocationGroupModal from "features/planner/components/View/EditLocationGroupModal";
import ReturnOnshoreModal from "features/planner/components/CreateCardMove/ReturnOnshoreModal";
import DeployOffshoreModal from "features/planner/components/CreateCardMove/DeployOffshoreModal";
import ShuttleOffshoreModal from "features/planner/components/CreateCardMove/ShuttleOffshoreModal";
import CreateViewGroupsModal from "features/planner/components/View/CreateViewGroups/CreateViewGroupsModal";
import SpecificationGapReportModal from "features/planner/components/CreateCardMove/SpecificationGapReportModal";

export const VIEW_EDIT_MODE = "edit";

class ViewContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      autoSave: false,
    };
  }

  getView = () => {
    const { viewId, dispatchGetView } = this.props;

    return dispatchGetView(viewId);
  };

  saveViewGroupOrder = () => {
    const { viewId, dispatchSaveViewGroupOrder } = this.props;

    return dispatchSaveViewGroupOrder(viewId);
  };

  maybeAutoSaveViewGroupOrder = () => {
    const { autoSave } = this.state;

    if (autoSave) {
      return this.saveViewGroupOrder();
    }
  };

  deleteViewGroupColumn = (type, column) => {
    const { viewId, dispatchDeleteViewGroupColumn } = this.props;

    dispatchDeleteViewGroupColumn(
      viewId,
      type,
      column,
      this.maybeAutoSaveViewGroupOrder,
    );
  };

  toggleAutoSave = () =>
    this.setState(({ autoSave }) => ({ autoSave: !autoSave }));

  render() {
    const { mode, viewId, searchTerm } = this.props;

    const isEditMode = mode === VIEW_EDIT_MODE;

    return (
      <>
        {isEditMode && (
          <ViewLayoutModeInfoPanel
            viewId={viewId}
            getView={this.getView}
            autoSave={this.state.autoSave}
            toggleAutoSave={this.toggleAutoSave}
            saveViewGroupOrder={this.saveViewGroupOrder}
          />
        )}
        {searchTerm && (
          <SearchResultTopPanel searchTerm={searchTerm} viewId={viewId} />
        )}
        <View
          key={viewId}
          viewId={viewId}
          isEditMode={isEditMode}
          deleteViewGroupColumn={this.deleteViewGroupColumn}
          saveViewGroupOrder={this.maybeAutoSaveViewGroupOrder}
        />
        <CreateCardModal />
        <EditCardModal />
        <CreateViewGroupsModal viewId={viewId} />
        <DeployOffshoreModal />
        <ShuttleOffshoreModal />
        <ReturnOnshoreModal />
        <EditCompanyModal />
        <EditLocationGroupModal />
        <SpecificationGapReportModal />
      </>
    );
  }
}

export default compose(
  connect(
    state => ({
      searchTerm: getSearchTermFromState(state),
    }),
    {
      dispatchGetView: getView,
      dispatchSaveViewGroupOrder: saveViewGroupOrder,
      dispatchDeleteViewGroupColumn: deleteViewGroupColumn,
    },
  ),
)(ViewContainer);
